import PropTypes from "prop-types"

const FilterBadgeContent = ({ label, value }) => {
  return (
    <>
      {label && <div className="filter-bar__type">{label}:&nbsp;</div>}
      <div className="filter-bar__name">{value}</div>
    </>
  )
}

FilterBadgeContent.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
}

export default FilterBadgeContent
